import type { ISalesCounterpart } from 'models/ISalesCounterpart';

export function findDefaultClient(
  clients: ReadonlyArray<ISalesCounterpart> | undefined,
): ISalesCounterpart | undefined {
  return clients?.length === 1 ? clients[0] : undefined;
}
